import { render, staticRenderFns } from "./FormListItem.vue?vue&type=template&id=5d0b917a&"
import script from "./FormListItem.vue?vue&type=script&lang=js&"
export * from "./FormListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports